/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { FunctionComponent, JSX } from "react";

interface CloseIconProps {
  className: string;
}

/**
 * Shared Close (X) glyph used by sub-panels within SeriesRecordingOptionsOverlay.
 * Callers supply the BEM class so each panel can apply its own sizing and colour tokens.
 */
const CloseIcon: FunctionComponent<CloseIconProps> = (
  props: CloseIconProps
): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/no-unused-vars, sonarjs/no-dead-store -- Required by CodingGuidelines §7 (D-09)
  const TAG: string = "CloseIcon";
  const { className } = props;
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M6 6l12 12M18 6L6 18"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CloseIcon;
